import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FEATURES_PAGE, BRAND } from "@/lib/constants";
import { Flag, Timer, Users } from "lucide-react";

const iconMap = { Flag, Timer, Users };

export default function FeaturesHero() {
  const { hero } = FEATURES_PAGE;

  return (
    <section
      data-testid="features-hero"
      className="bg-white pt-24 md:pt-32 pb-16 md:pb-20"
      aria-label="Features page hero"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center">
        <h1
          data-testid="features-headline"
          className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1A1A1A] leading-tight tracking-tight mb-6"
        >
          {hero.headline}
        </h1>

        <p
          data-testid="features-subheadline"
          className="text-base md:text-lg text-[#6B7280] leading-relaxed max-w-2xl mx-auto mb-8"
        >
          {hero.subheadline}
        </p>

        <div className="space-y-3">
          <Link to={BRAND.signupPath}>
            {/* Stripe checkout will connect here */}
            <Button
              data-testid="features-hero-cta"
              className="bg-[#D4A84B] hover:bg-[#B88E3B] text-white font-bold h-16 px-14 rounded-md shadow-md hover:shadow-lg transition-all active:scale-95 text-lg tracking-wide"
            >
              {hero.cta}
            </Button>
          </Link>
          <p className="text-sm text-[#6B7280]">{hero.ctaSubtext}</p>
        </div>

        {/* Trust indicators */}
        <div
          data-testid="features-trustbar"
          className="mt-10 pt-8 border-t border-gray-100 flex flex-wrap justify-center gap-6 md:gap-10"
        >
          {hero.trustItems.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.text}
                className="flex items-center gap-2 text-sm text-[#6B7280]"
                data-testid={`features-trust-${i}`}
              >
                {Icon && <Icon className="h-4 w-4 text-[#20611B]" />}
                <span>{item.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
